// Site
export const ALTERNATIVE_FORMAT_REQUEST_EMAIL = 'alternativeformats@homeoffice.gov.uk';
export const SERVICE_NAME = 'Review commercial and pleasure craft voyage reports';
export const SPCR_SERVICE_NAME = 'Review commercial and pleasure craft voyage reports';
export const FEEDBACK_URL = 'https://www.homeofficesurveys.homeoffice.gov.uk/s/AOYULB/';
export const HOMEOFFICE_SYSTEM_URL = 'https://www.cbp-bf.com/auth/login';
export const inSiteMaintenance = !!JSON.parse(process.env.NMSW_MAINTENANCE || false);
export const NMSW_REPORT_PROBLEMS_EMAIL = 'nmsw@homeoffice.gov.uk';
export const PAGE_SIZE = process.env.PAGE_SIZE || 20;

// Search bar labels and hints
export const SEARCH_ARRIVALS_LABEL = 'Search arrivals';
export const SEARCH_DEPARTURES_LABEL = 'Search departures';
export const USER_SEARCH_LABEL = 'Search by email or name';
export const SEARCH_ARRIVALS_AND_DEPARTURES_HINT = 'Search by skipper name, vessel name, registration number or MMSI number';

// Declaration Statuses
export const DECLARATION_STATUS_CANCELLED = 'Cancelled';
export const DECLARATION_STATUS_DRAFT = 'Draft';
export const DECLARATION_STATUS_FAILED = 'Failed';
export const DECLARATION_STATUS_PRECANCELLED = 'PreCancelled';
export const DECLARATION_STATUS_PRESUBMITTED = 'PreSubmitted';
export const DECLARATION_STATUS_SUBMITTED = 'Submitted';

// Types of people
export const PEOPLE_TYPE_PASSENGERS = 'passengers';
export const PEOPLE_TYPE_CREW = 'crew';

// UPT Status RESPONSE CODES
export const DECLARATION_UPT_STATUS_NO_RECORD_CODE = '0B';
export const DECLARATION_UPT_STATUS_AUTHORITY_TO_CARRY_GRANTED_CODE = '0Z';
export const DECLARATION_UPT_STATUS_PERMISSION_TO_TRAVEL_CODE = '0A';

// UPT statuses
export const statusFilters = [
  { value: DECLARATION_UPT_STATUS_NO_RECORD_CODE, name: 'No record of valid permission' },
  { value: DECLARATION_UPT_STATUS_AUTHORITY_TO_CARRY_GRANTED_CODE, name: 'Authority to carry granted' },
  { value: DECLARATION_UPT_STATUS_PERMISSION_TO_TRAVEL_CODE, name: 'Valid permission to travel' },
];
export const DECLARATION_UPT_STATUS_BOARD = 'Board';
export const DECLARATION_UPT_STATUS_CHECK = 'Check';
export const DECLARATION_UPT_STATUS_NO_RECORD = 'No record of valid permission';
export const DECLARATION_UPT_STATUS_NO_RECORD_DESCRIPTION = 'No record of valid permission to travel';
export const DECLARATION_UPT_STATUS_AUTHORITY_TO_CARRY_GRANTED = 'Authority to carry granted';
export const DECLARATION_UPT_STATUS_PERMISSION_TO_TRAVEL = 'Valid permission to travel';
export const DECLARATION_UPT_STATUS_SYSTEM_TIME_OUT = 'System time out';

// SPCR Dashboard
export const VOYAGE_REPORT_PERMISSION_NOT_GRANTED = 'Not granted';
export const VOYAGE_REPORT_VOYAGE_HIGH_RISK = 'High risk';
export const VOYAGE_REPORT_VOYAGE_RESTRICTED_GOODS = 'Restricted goods';

// SPCR Report review
export const CBP_STATUS_UNSUBMITTED = 'unsubmitted';
export const CBP_STATUS_SUBMITTED = 'submitted';
export const CBP_STATUS_FAILED = 'failed';
export const CBP_STATUS_CANCELLED = 'cancelled';

export const PERMISSION_STATUS_NOT_GRANTED = 'Not granted';
export const PERMISSION_STATUS_GRANTED = 'Granted';
export const PERMISSION_STATUS_REFUSED = 'Refused';

export const RISK_ASSESSMENT_AWAITING = 'Awaiting assessment';
export const RISK_ASSESSMENT_LOW = 'Low Risk';
export const RISK_ASSESSMENT_HIGH = 'High Risk';
export const RESTRICTED_GOODS = 'Restricted goods';
export const DESTINATION_UNKNOWN = 'Destination unknown';
export const DESTINATION_BF_UNKNOWN = 'Destination and BF team unknown';


// SPCR UPT Statuses     #TODO these must match the values returned by the API
export const SPCR_UPT_VALID_PERMISSION = 'Valid permission to travel';
export const SPCR_UPT_VALID_PERMISSION_MSG = SPCR_UPT_VALID_PERMISSION;
export const SPCR_UPT_NO_RECORD = 'No record of valid permission to travel';
export const SPCR_UPT_NO_RECORD_MSG = SPCR_UPT_NO_RECORD;

// Forms: display types
export const DISPLAY_DETAILS = 'details';
export const DISPLAY_SINGLE = 'single';
export const DISPLAY_GROUPED = 'grouped';

// Forms: identifiers
export const MULTI_PAGE_FORM = 'multiPageForm';
export const SINGLE_PAGE_FORM = 'singlePageForm';
export const SIGN_IN_FORM = 'signInForm';

// Forms: input types
export const INPUT_CHECKBOX = 'checkbox';
export const INPUT_EMAIL = 'email';
export const INPUT_PASSWORD = 'password';
export const INPUT_SELECT = 'select';
export const INPUT_RADIO = 'radio';
export const INPUT_TEXT = 'text';
export const TEXTAREA_MAX_CHAR = '200';

// Forms: validation types
export const VALIDATE_EMAIL_ADDRESS = 'emailAddress';
export const VALIDATE_INVITE_EMAIL_ADDRESS = 'inviteEmailAddress';
export const VALIDATE_FIELD_MATCH = 'match'; // not case sensitive e.g. `BaA` and `baa` will be a valid match
export const VALIDATE_FIELD_MATCH_CASE_SENSITIVE = 'matchCaseSensitive'; // e.g. `BaA` and `baa` will fail
export const VALIDATE_MAX_LENGTH = 'maxLength';
export const VALIDATE_MIN_LENGTH = 'minLength';
export const VALIDATE_REQUIRED = 'required';
export const VALIDATE_NO_SPACES = 'noSpaces';

// Forms: assigned names for various form elements
export const FORM_NAME_VOYAGE_TYPE = 'voyageType';
export const FORM_NAME_SELECT_TEAM = 'selectTeam';
export const FORM_NAME_SELECT_PORTS = 'selectPorts';
export const ARRIVAL_PORTS_FIELD_LABEL = 'arrival port';
export const FORM_NAME_SEARCHABLE_TEXT = 'searchableText';

// Forms: assigned static values for various form elements
export const FORM_VALUE_VOYAGE_TYPE_ARRIVAL = 'arrival';
export const FORM_VALUE_VOYAGE_TYPE_DEPARTURE = 'departure';
export const FORM_VALUE_SELECT_TEAM_ALL = 'All';
export const SPCR_TAB_ARRIVAL = 'arrival';
export const SPCR_TAB_DEPARTURE = 'departure';

// Manage user group filter values (must match InternalGroupsEnum)
export const GROUP_BORDER_SECURITY_COMMAND = 'Border Security Command';
export const GROUP_BORDER_FORCE = 'Border Force';
export const GROUP_BORDER_FORCE_USER = 'Border Force User';
export const GROUP_CTP = 'CTP';
export const GROUP_CTP_USER = 'CTP User';
export const GROUP_HMRC = 'HMRC';
export const GROUP_HMRC_USER = 'HMRC User';
export const GROUP_JMSC = 'JMSC';
export const GROUP_JMSC_USER = 'JMSC User';
export const GROUP_MCGA = 'MCGA';
export const GROUP_MCGA_USER = 'MCGA User';
export const GROUP_MIB_INTELLIGENCE = 'MIB Intelligence';
export const GROUP_MIB_INTELLIGENCE_USER = 'MIB Intelligence User';
export const GROUP_POLICE = 'Police';
export const GROUP_POLICE_USER = 'Police User';

// User types
export const USER_TYPE_ADMIN = 'Admin';
export const USER_TYPE_ADMIN_LABEL = 'Admin user';
export const USER_TYPE_STANDARD = 'User';
export const USER_TYPE_STANDARD_LABEL = 'Standard user';
export const USER_GROUP_INTERNAL = 'Internal';
export const USER_GROUP_EXTERNAL = 'External';
export const INTERNAL_TEAMS = ['Border Force Team'];

// Admin group types - as found in the api /sign-in response "groups" array
export const GROUP_TYPE_BSC = '/Border Security Command';
export const GROUP_TYPE_BF = '/Border Force';
export const GROUP_TYPE_MIB = '/MIB Intelligence';
export const GROUP_TYPE_JMSC = '/JMSC';
export const GROUP_TYPE_POL = '/Police';
export const GROUP_TYPE_CTP = '/CTP';
export const GROUP_TYPE_HMRC = '/HMRC';
export const GROUP_TYPE_MCGA = '/MCGA';
export const GROUP_TYPE_NCA = '/NCA';

/*
export const GROUPS = [ADMIN_TYPE_BSC, '/Border Force',
  '/MIB Intelligence', '/JMSC', '/Police', '/CTP',
  '/HMRC', '/MCGA', '/NCA', '/Border Force User',
  '/MIB Intelligence User', '/JMSC User', '/Police User',
  '/CTP User', '/HMRC User', '/MCGA User', '/NCA User'
];
*/

// All known Admin groups
export const ADMIN_GROUP_ALL = [
  GROUP_TYPE_BSC,
  GROUP_TYPE_BF,
  GROUP_TYPE_MIB,
  GROUP_TYPE_JMSC,
  GROUP_TYPE_POL,
  GROUP_TYPE_CTP,
  GROUP_TYPE_HMRC,
  GROUP_TYPE_MCGA,
  GROUP_TYPE_NCA,
];

export const ADMIN_TYPE_BSC = 'ADMIN_TYPE_BSC';

// Admin group subcategory type A
export const ADMIN_GROUP_A = [
  GROUP_TYPE_BF,
  GROUP_TYPE_MIB,
  GROUP_TYPE_JMSC,
];
export const ADMIN_TYPE_GROUP_A = 'ADMIN_TYPE_GROUP_A';

// Admin group subcategory type B
export const ADMIN_GROUP_B = [
  GROUP_TYPE_POL,
  GROUP_TYPE_CTP,
  GROUP_TYPE_HMRC,
  GROUP_TYPE_MCGA,
  GROUP_TYPE_NCA,
];
export const ADMIN_TYPE_GROUP_B = 'ADMIN_TYPE_GROUP_B';

// All known User (non-admin) groups
export const STANDARD_GROUP = [
  '/Border Force User',
  '/MIB Intelligence User',
  '/JMSC User',
  '/Police User',
  '/CTP User',
  '/HMRC User',
  '/MCGA User',
  '/NCA User',
];

// Invite Team Member
export const INVITE_PAGE_HEADING = 'Add a new user';
export const INVITE_TYPE_A_HINT = 'Can add and manage users, view NMSW and sPCR reports and complete actions.';
export const INVITE_TYPE_B_HINT = 'Can add and manage users and view NMSW and sPCR reports.';
export const INVITE_STANDARD_TYPE_A_HINT = 'Can view NMSW and sPCR reports and complete actions.';
export const INVITE_STANDARD_TYPE_B_HINT = 'Can view NMSW and sPCR reports.';
export const INVITE_EMAIL_INPUT_TEXT = 'Organisation email address';
export const INVITE_EMAIL_ERROR = 'Enter an authorised email address';
export const INVITE_EMAIL_REQUIRED_MESSAGE = 'Enter an organisation email address';

// Message components
export const MESSAGE_ALREADY_REGISTERED = 'alreadyRegistered';
export const INVITE_LINK_ERROR_TITLE = 'The link you entered has not worked';
export const INVITE_LINK_ERROR_MESSAGE = 'You may need to copy and paste the full link into your browser';

// Pagination
export const PAGINATION_DISPLAYABLE_PAGE_NUMBER_INCREMENT = 1;
export const PAGINATION_ELLIPSIS = '\u22EF'; // midline horizontal ellipsis
export const PAGINATION_GOTO_PAGE_ACTION = 'gotoPage';
export const PAGINATION_IDENTIFIER = 'pagination';
export const PAGINATION_INITIAL_OFFSET = 0;
export const PAGINATION_INITIAL_PAGE_INDEX = 0;
export const PAGINATION_NEXT_ACTION = 'next';
export const PAGINATION_NEXT_ARIA_LABEL = 'Next page';
export const PAGINATION_NEXT_PAGE = 'next';
export const PAGINATION_NEXT_TEXT = 'Next';
export const PAGINATION_PAGE_IDENTIFIER = 'pageStart';
export const PAGINATION_PAGE_START_STORAGE_KEY = 'paginationPageStart';
export const PAGINATION_PREVIOUS_ACTION = 'previous';
export const PAGINATION_PREVIOUS_ARIA_LABEL = 'Previous page';
export const PAGINATION_PREVIOUS_PAGE = 'previous';
export const PAGINATION_PREVIOUS_TEXT = 'Previous';
export const PAGINATION_USERS_PER_PAGE = 20;

// SPCR Internal
export const COMMERCIAL_VESSEL_VOYAGE_REPORTS = 'Commercial vessel voyage reports';
export const MANAGE_USERS = 'Manage users';
export const MANAGE_USERS_ALL_USERS = 'All users';
export const OPTIONAL_COMMENT_ACTION = 'Comment added';
export const OPTIONAL_COMMENT_ERROR_MSG = 'Enter an optional comment';
export const PLEASURE_CRAFT_VOYAGE_REPORTS = 'Pleasure craft voyage reports';
export const GENERIC_ERROR_MESSAGE = 'Sorry, there is a problem with the service';
export const SUPPORT_EMAIL = 'spcr@homeoffice.gov.uk';
